import axios from "axios";
// Get base URL from .env file
const baseUrl = process.env.REACT_APP_API_URL;

/**
 * Sends navigation tracking data containing the userId, sessionid, and currentPath.
 *
 * @param {Object} trackingData - The navigation data.
 * @param {string} trackingData.userId - The user's ID.
 * @param {string} trackingData.sessionid - The session identifier.
 * @param {string} trackingData.pageUrl - The current URL path including query parameters.
 * @returns {Promise<Object>} - Returns the API response data.
 */
export const trackNavigation = async (trackingData) => {
  try {
    // Send the trackingData as JSON to the specified endpoint.
    const response = await axios.post(
      `${baseUrl}/api/Coltec/save-pageview`,
      trackingData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    // Optionally, handle error logging or user notifications here.
    throw error;
  }
};
